import {Action} from '@ngrx/store';

export const ADD_TRIAL_USER_WITH_AUDIT = 'ADD_TRIAL_USER_WITH_AUDIT';
export const SET_TRIAL_STEP_PARAM = 'SET_TRIAL_STEP_PARAM';

export class AddTrialUserWithAudit implements Action {
  readonly type = ADD_TRIAL_USER_WITH_AUDIT;

  constructor(public payload: {profile: string, userUid: string}) {
  }
}

export class SetTrialStepParam implements Action {
  readonly type = SET_TRIAL_STEP_PARAM;

  constructor(public payload: {stepName: string, paramName: string, value: any}) {}
}

export type TrialActions = AddTrialUserWithAudit | SetTrialStepParam;
